import type { AuthClient } from "./auth.types";

let logged = false;
const fakeAccount = {
  username: "dev.user@contoso.com",
  homeAccountId: "fake-account-id",
};

export const fakeAuthClient: AuthClient = {
  async loginRedirect() {
    logged = true;
    return;
  },
  async logoutRedirect(args) {
    logged = false;
    return;
  },
  async acquireTokenSilent() {
    return { accessToken: "FAKE_MSAL_ACCESS_TOKEN_DEV_MODE" };
  },
  getAccounts() {
    return logged ? [fakeAccount] : [];
  },
  getInProgress() {
    return "none";
  },
  isAuthenticated() {
    return logged;
  },
  async handleRedirect() {
    logged = false;
    return;
  },
};
